export const LOCATION_DEFAULT_VALUES = {
  address1: '',
  address2: '',
  businessName: '',
  city: '',
  country: '',
  latitude: '',
  longitude: '',
  state: {
    id: Infinity,
    label: '',
    value: '',
  },
  type: {
    id: Infinity,
    label: '',
    value: '',
  },
  zipCode: '',
  verified: false,
};

export const LOCATION_TITLES = {
  storage: 'Stored Location',
  google: 'API Verified Location',
};
